// extracted by mini-css-extract-plugin
export default {"poster":"PosterArea_poster__DT-qb","focusParts":"PosterArea_focusParts__Si9BZ","endLine":"PosterArea_endLine__4UX+9","endline":"PosterArea_endline__cL3pP"};